<script>
  import {useQuery} from "@sveltestack/svelte-query";
  import PageTitle from "../parts/PageTitle.svelte";
  import { getAutoMpsProjectContext } from "../AutoMpsProjectContext.js";
  import Loading from "../../components/pages/Loading.svelte";
  import Stack from "../../components/layout/Stack.svelte";
  import AutoMpsExecutionCard from "./AutoMpsExecutionCard.svelte";

  const ctx = getAutoMpsProjectContext()

  const query = useQuery(
    `/api/auto-mps/projects/${$ctx.projectId}/executions?direction=past`
  )

</script>

<div class="content-root">
  <PageTitle>過去の実行一覧</PageTitle>
  <div style="padding-left: 1rem">過去の実行のうち、最近の10回を表示しています。</div>
  {#if $query.isLoading}
    <Loading />
  {:else}
    <Stack direction="vertical" gap="1rem">
      {#each $query.data.executions as execution}
        <AutoMpsExecutionCard execution={execution} />
      {/each}
    </Stack>
  {/if}
</div>

<style>
  .content-root {
    height: 100%;
    background-color: white;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }
</style>
